import { LoadState } from "../../../constants/enums";
import { IBulkInvoices } from "../InvoiceInformation/InvoiceInformation.types";

export interface IRecurringInvoiceItem {
  accn_recurring_invoice_items_id: number | null;
  invoice_for: string | null;
  broker_sub_code: string | null;
  broker_code: string | null;
  transaction_type: string | null;
  gl_account_code: string | null;
  gl_sales_account_name: string | null;
  description: string | null;
  detail: string | null;
  amount: string | null;
  payment_terms: string | null;
  name: string | null;
  code: string | null;
  policy_id: string | null;
  policy_number: string | null;
  policy_type: string | null;
  policy_transaction_type: string | null;
  policy_status: string | null;
  effective_date: string | null;
  expiry_date: string | null;
  default_tax_region: string | null;
  agency_or_direct_bill: string | null;
  agency_bill_commission: string | null;
  direct_bill_commission: string | null;
  agency_bill_receivables: string | null;
  direct_bill_receivables: string | null;
  premium_financed: string | null;
  financed_by: string | null;
  financed_fee: string | null;
  producer_one_id: string | null;
  producer_one_code: string | null;
  producer_two_id: string | null;
  producer_two_code: string | null;
  producer_three_id: string | null;
  producer_three_code: string | null;
  csr_code: string | null;
  branch: string | null;
  branch_code: string | null;
  insurer_code: string | null;
  tax_one_percentage: string | null;
  tax_one_amount: string | null;
  tax_two_percentage: string | null;
  tax_two_amount: string | null;
  commission_percentage: string | null;
  commission_amount: string | null;
  house_percentage: string | null;
  house_amount: string | null;
  producer_one_percentage: string | null;
  producer_one_amount: string | null;
  producer_two_percentage: string | null;
  producer_two_amount: string | null;
  producer_three_percentage: string | null;
  producer_three_amount: string | null;
  branch_percentage: string | null;
  branch_amount: string | null;
  total_amount: string | null;
  total_due_dollar: string | null;
  net_payable_insurer: string | null;
}

export interface IRecurringInvoice {
  accn_recurring_invoices_id: number | null;
  recurring_invoice_code: string | null;
  frequency: string;
  start_date: string | null;
  end_date: string | null;
  next_run_date: string | null;
  last_run_date: string | null;
  max_occurrences: number | null;
  occurrence_count: number | null;
  is_future: number;
  status: string;
  amount: string | null;
  policy_id: string | null;
  policy_number: string | null;
  customer_name: string | null;
  created_by_id: number | null;
  created_by_name: string | null;
  modified_by_id: number | null;
  modified_by_name: string | null;
  create_ts: string | null;
  insert_ts: string | null;
  INVOICES?: IRecurringInvoiceItem[];
}

export interface IRecurringInvoiceUpsertPayload {
  accn_recurring_invoices_id: number | null;
  frequency: string;
  start_date: string | null;
  end_date: string | null;
  max_occurrences: number | null;
  is_future: number;
  status: string;
  amount: string | null;
  policy_id: string | null;
  INVOICES: IBulkInvoices[];
}

export interface IRecurringInvoiceState {
  list: IRecurringInvoice[];
  listLoading: LoadState;
  totalRecords: number;
  data: IRecurringInvoice;
  dataLoading: LoadState;
  error: string | null;
}

export const initialRecurringInvoice: IRecurringInvoice = {
  accn_recurring_invoices_id: null,
  recurring_invoice_code: null,
  frequency: "daily",
  start_date: null,
  end_date: null,
  next_run_date: null,
  last_run_date: null,
  max_occurrences: null,
  occurrence_count: null,
  is_future: 0,
  status: "active",
  amount: null,
  policy_id: null,
  policy_number: null,
  customer_name: null,
  created_by_id: null,
  created_by_name: null,
  modified_by_id: null,
  modified_by_name: null,
  create_ts: null,
  insert_ts: null,
  INVOICES: [],
};

export const initialRecurringInvoiceState: IRecurringInvoiceState = {
  list: [],
  listLoading: LoadState.NotLoaded,
  totalRecords: 0,
  data: initialRecurringInvoice,
  dataLoading: LoadState.NotLoaded,
  error: null,
};
